<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Add Form Field</h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div class="modal-body text-grey">
  <form [formGroup]="addFieldForm" autocomplete="off" spellcheck="false">
    <div class="mb-3 row">
      <label for="fieldType" class="col-sm-3 fs-6 col-form-label">Type </label>
      <div class="col-sm-9">
        <select
          class="form-control form-select"
          id="fieldType"
          formControlName="fieldType"
          (change)="fieldTypeUpdated()"
        >
          <option *ngFor="let field of toAddFields" [value]="field.value">
            {{ field.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="fieldName" class="col-sm-3 fs-6 col-form-label">
        Name
        <span
          class="bi bi-info-circle-fill synchpc-primary"
          placement="bottom"
          container="body"
          [autoClose]="true"
          (mouseover)="getTooltip('fieldName')"
          triggers="hover" [ngbTooltip]="addFieldTooltip"
        >
        </span>
      </label>
      <div class="col-sm-9">
        <input
          type="text"
          class="form-control"
          id="fieldName"
          formControlName="fieldName"
        />
        <small *ngIf="addFieldForm.get('fieldName').touched && addFieldForm.get('fieldName').errors?.required" class="text-danger">Field name is required.</small>
        <small class="text-danger" *ngIf="alreadyAddedNames.includes(addFieldForm.controls['fieldName'].value | lowercase)">Please enter unique name.</small>
      </div>
    </div>
    <div
      class="mb-3 row"
      *ngIf="!['inputFile'].includes(addFieldForm.controls['fieldType'].value)"
    >
      <label for="fieldValue" class="col-sm-3 fs-6 col-form-label">
        Value
        <span
          class="bi bi-info-circle-fill synchpc-primary"
          placement="bottom"
          container="body"
          [autoClose]="true"
          (mouseover)="getTooltip('fieldValue')"
          triggers="hover" [ngbTooltip]="addFieldTooltip"
        >
        </span>
      </label>
      <div class="col-sm-9">
        <input
          type="text"
          class="form-control"
          id="fieldValue"
          formControlName="fieldValue"
          *ngIf="['textbox', 'dropdown'].includes(addFieldForm.controls['fieldType'].value)"
        />
        <select
          class="form-control form-select"
          id="fieldValue"
          formControlName="fieldValue"
          *ngIf="['checkbox'].includes(addFieldForm.controls['fieldType'].value)"
        >
          <option value="true">True</option>
          <option value="false">False</option>
        </select>
        <small *ngIf="addFieldForm.get('fieldValue').touched && addFieldForm.get('fieldValue').errors" class="text-danger">field value is required.</small>
      </div>
    </div>
    <div class="mt-4 mb-0 text-center" *ngIf="!['checkbox'].includes(addFieldForm.controls['fieldType'].value)">
      <mat-checkbox
        formControlName="isFieldRequired"
        title="This field will be required while submitting job."
      >
        Set Mandatory ?
      </mat-checkbox>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
    Close
  </button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()">
    Add
  </button>
</div>
<ng-template #addFieldTooltip>
  <div *ngIf="tooltipHtml != ''" [innerHTML]="tooltipHtml | safeHtml"></div>
</ng-template>
